// First letter of every word in capitals; the rest stays as typed (mirrors backend/pro_names.py).
// "rahul  kumar" -> "Rahul Kumar", "ABC interiors" -> "ABC Interiors".
export function capitalise(name) {
  if (typeof name !== "string" || !name.trim()) return name;
  return name.trim().replace(/\s+/g, " ").replace(/(^|[\s\-/(&.])([a-zà-ÿ])/g, (_, a, b) => a + b.toUpperCase());
}
